import(/* webpackMode: "eager" */ "/home/ubuntu/download/698a07d0f782d50014fe8cc3/aviationstudy/src/app/not-found.tsx");
